export default __webpack_public_path__ + "static/media/warning--quay-or-river-bank--g3.115341dd.png";